'use strict';

const uuid = require('node-uuid');

/**
 * KDContext Error
 *
 * This error denotes a base KDContext Error
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} [context] - Type-specific error context data
 */
class KDContextError extends Error {
    constructor(message, detail, context) {
        super();
        this.message = message || 'Unknown Error Message';
        this.detail = detail;
        this.context = context;
        this.name = 'KDContextError';
        this.status = 500;
        this.id = uuid.v4();

        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor);
        } else {
            this.stack = (new Error(message)).stack;
        }
    }

    toJSON() {
        const json = {
            id: this.id,
            status: this.status,
            title: this.message,
            detail: this.detail || this.message,
        };

        if (this.context) {
            json.meta = this.context;
        }

        return json;
    }
}

module.exports = KDContextError;



/** WEBPACK FOOTER **
 ** ./src/common/error/kd-context.js
 **/